import { render, staticRenderFns } from "./EducationalGroupStudentFilter.vue?vue&type=template&id=394eac2c&"
import script from "./EducationalGroupStudentFilter.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStudentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports